import IconAsyncSelect from './IconAsyncSelect';

export default IconAsyncSelect;
